'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useEffect, useState } from 'react'

// walrus
import { accessibilityLabel } from '@components/kit/_support'
import { useNavigate } from 'react-router-dom'
import Box from '@components/kit/box'
import Page from '@components/kit/page'
import Screen from '@components/kit/screen'

// lib
import LoginForm from './login-form'
import MfaForm from './mfa-form'
import { useAuthStore } from '@store/Auth'
import { LoginCredentials, LoginMfaChallengeResponse } from '@store/Auth/types'

/* -----------------------------------------------------------------------------
 * Login
 * -------------------------------------------------------------------------- */

type LoginStep = 'credentials' | 'mfa'

function Login() {
  const navigate = useNavigate()
  const accessToken = useAuthStore(state => state.accessToken)

  const [step, setStep] = useState<LoginStep>('credentials')
  const [email, setEmail] = useState('')
  const [mfaValue, setMfaValue] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (accessToken) {
      navigate('/home')
    }
  }, [accessToken])

  const handleMfaRequired = (
    mfa: LoginMfaChallengeResponse,
    credentials: LoginCredentials
  ) => {
    setEmail(credentials.email)
    setMfaValue(mfa.mfa_value)
    setStep('mfa')
  }

  const handleBackToLogin = () => {
    setEmail('')
    setMfaValue(undefined)
    setStep('credentials')
  }

  return (
    <Screen
      {...accessibilityLabel('Login')}
      keyboardShouldPersistTaps='handled'
      bg='white'
    >
      <Box
        flexDirection='column'
        flex='1 0 auto'
        alignItems='center'
        justifyContent='center'
      >
        <Page flex='0 0 auto'>
          {step === 'mfa' ? (
            <MfaForm
              flex='1 0 auto'
              pt='24'
              width='100%'
              email={email}
              mfaValue={mfaValue}
              onBack={handleBackToLogin}
            />
          ) : (
            <LoginForm
              flex='1 0 auto'
              pt='24'
              width='100%'
              onMfaRequired={handleMfaRequired}
            />
          )}
        </Page>
      </Box>
    </Screen>
  )
}

export default Login
